export const SIDEBAR_PADDING = 40; // space.250 * 2 = 40px
export const SINGLE_SELECT_CHART_PADDING = 24; // space.150 * 2 = 24px
